/* global axios */

import ApiClient from './ApiClient';

class CustomRole extends ApiClient {
  constructor() {
    super('custom_roles', { accountScoped: true });
  }

  getDefaultPresets() {
    return axios.get(`${this.url}/default_presets`);
  }

  installDefaults() {
    return axios.post(`${this.url}/install_defaults`);
  }
}

export default new CustomRole();
